var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content",style:({ color: _vm.colorValue }),on:{"click":_vm.clickNumber}},[_c('div',[_vm._v(" "+_vm._s(_vm.statisticsValue)),_c('span',[_vm._v(_vm._s(_vm.unitLabel))])])])}
var staticRenderFns = []

export { render, staticRenderFns }